<template>
  <div>
    <template v-if="mode === 'fields'">
      <!-- 手動入力フィールド（AI自動入力でないテンプレート用） -->
      <div class="edit-form-item" v-if="!showAiCard">
        <div class="item-name">役職・部署名</div>
        <div class="item-body">
          <el-input class="input-md" placeholder="" title="役職・部署名"
            v-model="basicData.yakushokuBusho"></el-input>
        </div>
        <div class="item-name">業種</div>
        <div class="item-body">
          <el-select v-model="basicData.gyoushuCd" placeholder="選択してください" style="left:0;max-width: 100%;">
            <el-option-group v-for="group in industryData" :key="group.igCd" :label="group.label">
              <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-option-group>
          </el-select>
        </div>
        <div class="item-name">職種</div>
        <div class="item-body">
          <el-select v-model="basicData.shokushuCd" placeholder="選択してください" style="left:0;max-width: 100%;">
            <el-option-group v-for="group in jobTypeData" :key="group.jgCd" :label="group.label">
              <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-option-group>
          </el-select>
        </div>
        <div class="item-name">希望業種</div>
        <div class="item-body">
          <el-select v-model="basicData.kibouGyoushuCd" placeholder="選択してください" style="left:0;max-width: 100%;">
            <el-option-group v-for="group in industryData" :key="group.igCd" :label="group.label">
              <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-option-group>
          </el-select>
        </div>
        <div class="item-name">希望職種</div>
        <div class="item-body">
          <el-select v-model="basicData.kibouShokushuCd" placeholder="選択してください" style="left:0;max-width: 100%;">
            <el-option-group v-for="group in jobTypeData" :key="group.jgCd" :label="group.label">
              <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-option-group>
          </el-select>
        </div>
      </div>

      <!-- 年収フィールド -->
      <div class="edit-form-item">
        <div class="item-name">現在の年収</div>
        <div class="item-body">
          <el-select v-model="formatData.nowNensyu" placeholder="選択してください" style="left:0;max-width: 100%;">
            <el-option label="399万円以下" value="399万円以下"></el-option>
            <el-option label="400万円以上" value="400万円以上"></el-option>
            <el-option label="700万円以上" value="700万円以上"></el-option>
          </el-select>
        </div>
        <div class="item-name">希望年収</div>
        <div class="item-body">
          <el-input class="input-xs" placeholder="" title="希望年収" type="number"
            v-model="formatData.kibouNensyu"></el-input> 万円
        </div>
      </div>
      <div class="item-name" style="font-size: 0.8rem;">※上記項目を入力した後、例文から追加ボタンをクリックして例文を選択すると自動的に反映されます。</div>
    </template>

    <template v-if="mode === 'ai-card'">
      <!-- AI自動入力 編集モーダル -->
      <modal v-if="showAiCard" name="request-edit-dialog" :adaptive="true" :scrollable="true" height="auto">
        <div class="v--modal-close-top">
          <el-button @click="$modal.hide('request-edit-dialog');" icon="el-icon-close" type="text"></el-button>
        </div>
        <div class="title">職種などの編集</div>
        <div class="description" style="padding: 16px;">
          <div class="edit-form-item">
            <div class="item-name">役職・部署名</div>
            <div class="item-body">
              <el-input class="input-md" placeholder="役職・部署名" v-model="basicData.yakushokuBusho"></el-input>
            </div>
            <div class="item-name">業種</div>
            <div class="item-body">
              <el-select v-model="basicData.gyoushuCd" filterable placeholder="選択してください" style="left:0;max-width: 100%;">
                <el-option-group v-for="group in bizreachIndustryGroups" :key="group.igCd" :label="group.label">
                  <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-option-group>
              </el-select>
            </div>
            <div class="item-name">職種</div>
            <div class="item-body">
              <el-select v-model="basicData.shokushuCd" filterable placeholder="選択してください" style="left:0;max-width: 100%;">
                <el-option-group v-for="group in bizreachJobCategoryGroups" :key="group.jgCd" :label="group.label">
                  <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-option-group>
              </el-select>
            </div>
            <div class="item-name">希望業種</div>
            <div class="item-body">
              <el-select v-model="basicData.kibouGyoushuCd" filterable placeholder="選択してください" style="left:0;max-width: 100%;">
                <el-option-group v-for="group in bizreachIndustryGroups" :key="group.igCd" :label="group.label">
                  <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-option-group>
              </el-select>
            </div>
            <div class="item-name">希望職種</div>
            <div class="item-body">
              <el-select v-model="basicData.kibouShokushuCd" filterable placeholder="選択してください" style="left:0;max-width: 100%;">
                <el-option-group v-for="group in bizreachJobCategoryGroups" :key="group.jgCd" :label="group.label">
                  <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-option-group>
              </el-select>
            </div>
          </div>
        </div>
        <div class="text-right" style="padding: 16px;">
          <el-button @click="$modal.hide('request-edit-dialog');">閉じる</el-button>
        </div>
      </modal>

      <!-- AI自動入力カード -->
      <div v-if="showAiCard" style="margin-top: 16px;">
        <div v-if="requestAiLoading" class="text-center" style="padding: 20px;">
          <i class="el-icon-loading" style="font-size: 24px;"></i>
          <p style="margin-top: 8px; color: #909399;">AIが入力データを分析中...</p>
        </div>
        <div v-else-if="requestAiError" style="padding: 12px; background: #fef0f0; border-radius: 4px; margin-bottom: 12px;">
          <p style="color: #f56c6c; margin: 0;">{{ requestAiError }}</p>
        </div>
        <div v-else-if="requestAiGenerated">
          <div style="background: #f5f7fa; border-radius: 4px; padding: 12px;">
            <div style="margin-bottom: 8px;"><span style="color: #909399; font-size: 12px;">役職・部署名:</span> <span>{{ basicData.yakushokuBusho || '(未設定)' }}</span></div>
            <div style="margin-bottom: 8px;"><span style="color: #909399; font-size: 12px;">業種:</span> <span>{{ getIndustryName(basicData.gyoushuCd) || '(未設定)' }}</span></div>
            <div style="margin-bottom: 8px;"><span style="color: #909399; font-size: 12px;">職種:</span> <span>{{ getJobCategoryName(basicData.shokushuCd) || '(未設定)' }}</span></div>
            <div style="margin-bottom: 8px;"><span style="color: #909399; font-size: 12px;">希望業種:</span> <span>{{ getIndustryName(basicData.kibouGyoushuCd) || '(未設定)' }}</span></div>
            <div style="margin-bottom: 8px;"><span style="color: #909399; font-size: 12px;">希望職種:</span> <span>{{ getJobCategoryName(basicData.kibouShokushuCd) || '(未設定)' }}</span></div>
            <div style="text-align: right;">
              <el-button size="small" type="danger" @click="$modal.show('request-edit-dialog')">編集</el-button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'PersonalRequestFields',
  props: {
    mode: {
      type: String,
      default: 'fields',
      validator: function (value) {
        return ['fields', 'ai-card'].indexOf(value) !== -1
      }
    },
    formatData: {
      type: Object,
      required: true
    },
    basicData: {
      type: Object,
      required: true
    },
    formatId: {
      type: String,
      required: true
    },
    industryData: {
      type: Array,
      required: true
    },
    jobTypeData: {
      type: Array,
      required: true
    },
    showAiCard: {
      type: Boolean,
      default: false
    },
    requestAiGenerated: {
      type: Boolean,
      default: false
    },
    requestAiLoading: {
      type: Boolean,
      default: false
    },
    requestAiError: {
      type: String,
      default: ''
    },
    bizreachIndustryGroups: {
      type: Array,
      default: () => []
    },
    bizreachJobCategoryGroups: {
      type: Array,
      default: () => []
    },
    getIndustryName: {
      type: Function,
      default: () => () => ''
    },
    getJobCategoryName: {
      type: Function,
      default: () => () => ''
    }
  }
}
</script>
